export class DropdownHover {
  constructor() {
    return {
      link: function(scope, element, attr) {
        var closeTimer = null;

        var getTarget = () => angular.element(attr.dropdownToggle);

        var closeNow = () => {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
          element[0].classList.remove('expanded');
          getTarget().css({ top: '', left: '' }).removeClass('open f-open-dropdown');
          scope.$apply(() => { scope.configMenuStatus = false; });
        };

        var open = () => {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
          angular.element('.f-dropdown.open').removeClass('open f-open-dropdown');
          angular.element('[dropdown-toggle].expanded').removeClass('expanded');
          element[0].classList.add('expanded');
          var target = getTarget();
          var rect = element[0].getBoundingClientRect();
          var offsetParent = target[0].offsetParent || document.body;
          var parentRect = offsetParent.getBoundingClientRect();
          target.css({ top: (rect.bottom - parentRect.top) + 'px', left: (rect.left - parentRect.left) + 'px' });
          target.addClass('open f-open-dropdown');
          scope.configMenuStatus = true;
          target.find('a').off('click.ddhover').on('click.ddhover', closeNow);
        };

        var scheduleClose = () => {
          closeTimer = setTimeout(function() {
            element[0].classList.remove('expanded');
            getTarget().css({ top: '', left: '' }).removeClass('open f-open-dropdown');
            scope.$apply(() => { scope.configMenuStatus = false; });
          }, 150);
        };

        element.on('mouseenter', open);
        element.on('mouseleave', scheduleClose);

        getTarget().on('mouseenter', function() {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        });
        getTarget().on('mouseleave', scheduleClose);
      }
    };
  }
}
